// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resetFilter__R2zme {
  width: 30px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  box-shadow: none;
}
@media (max-width: 1280px) {
  .resetFilter__R2zme {
    padding-top: 0;
    top: 0;
  }
}

@media (max-width: 1280px) {
  .clear-filter-icon__r2aLh {
    display: none;
  }
}

.resetIcon__hmH4q {
  cursor: pointer;
  outline: 0;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/ResetButton/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAzEF;AA0EE;EARF;IASI,cAAA;IACA,MAAA;EAvEF;AACF;;AA2EE;EADF;IAEI,aAAA;EAvEF;AACF;;AA0EA;EACE,eAAA;EACA,UAAA;EACA,gBAAA;AAvEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.resetFilter {\n  width: 30px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: 0;\n  box-shadow: none;\n  @media (max-width: 1280px) {\n    padding-top: 0;\n    top: 0;\n  }\n}\n\n.clear-filter-icon {\n  @media (max-width: 1280px) {\n    display: none;\n  }\n}\n\n.resetIcon {\n  cursor: pointer;\n  outline: 0;\n  box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resetFilter": `resetFilter__R2zme`,
	"clearFilterIcon": `clear-filter-icon__r2aLh`,
	"resetIcon": `resetIcon__hmH4q`
};
module.exports = ___CSS_LOADER_EXPORT___;
